const PERIOD_TOKEN = /\b(?:[1-4][qhp]|[qhp][1-4])\b/gi;

export const SPREAD_MARKET = /spread|run_line|puck_line|handicap/;

export function periodCase(market: string): string {
  return market.replace(PERIOD_TOKEN, (token) => token.toUpperCase());
}

export function playerMarketLabel(raw: string): string {
  const cleaned = periodCase(raw.replace(/^Player\s+/i, ""));
  return cleaned.length > 0 ? cleaned.charAt(0).toUpperCase() + cleaned.slice(1) : cleaned;
}
